import { Scale } from "../../types";

export const DEFAULT_SCALE: Scale = {
  width: 10000,
  height: 10000
} as const
